import { render, staticRenderFns } from "./ComisionesData.vue?vue&type=template&id=78b58a15&"
import script from "./ComisionesData.vue?vue&type=script&lang=js&"
export * from "./ComisionesData.vue?vue&type=script&lang=js&"
import style0 from "./ComisionesData.vue?vue&type=style&index=0&id=78b58a15&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports